import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const Kentucky = () => {
  return (
    <StatePropertyTaxPage
      stateName="Kentucky"
      processDescription="Annual open inspection/conference period begins first Monday in May for 13 days (includes Saturdays). You first request a conference online or by phone/email. If unresolved, you can appeal to the Local Board of Assessment Appeals (via County Clerk within one business day after conference period). Further appeals go to the Kentucky Board of Tax Appeals."
      noticeOfValueMailed="April"
      noticeOfValueMailedDateExplanation="Assessment notices are mailed in April before open inspection period."
      valuationAsOfDate="January 1"
      valuationAsOfDateExplanation="Under KRS 132.220, all real property is assessed based on fair cash value as of January 1 each year. This standardized assessment date ensures consistent property valuations across all counties in Kentucky."
      deadlineExplanation="Property owners must file during the Open Inspection Period, typically the first Monday in May for 13 days. This is a brief but critical window that requires property owners to act quickly to preserve their appeal rights."
    />
  );
};

export default Kentucky;